/* Versandbetrag ins Produkt-Markup nachtragen, in der Waehrung des Marktes.
 *
 * WARUM ES DIESE DATEI GIBT: der Versandbetrag liegt serverseitig nur in Euro
 * vor, und den Tageskurs kennt Liquid nicht. Im Browser steht er in
 * `Shopify.currency.rate` — derselbe Wert, mit dem das Kaufband seinen
 * sichtbaren Betrag umschreibt. Damit rechnet dieses Skript und setzt
 * `shippingRate` in jedes Angebot des JSON-LD.
 *
 * WARUM ERST HIER UND NICHT IM MARKUP: eine Euro-Zahl mit dem Etikett NOK
 * waere eine falsche Angabe, und genau die stand bis zum 15.09.2026 drin.
 * Der Server laesst den Betrag deshalb weg; er erscheint erst, wenn er
 * richtig benannt werden kann. Zielland und Lieferzeit stehen unabhaengig
 * davon schon im Markup, die haengen nicht am Kurs.
 *
 * WARUM DAS FUER SUCHMASCHINEN REICHT: Google liest strukturierte Daten aus
 * dem gerenderten DOM, nicht aus der ersten Antwort. Wer kein JavaScript
 * ausfuehrt, sieht ein Angebot ohne Versandbetrag, also weniger Angabe statt
 * einer falschen. Das ist die Richtung, in die ein Fehler fallen darf.
 *
 * IN EURO-MAERKTEN TUT DIESE DATEI NICHTS: dort steht der Betrag bereits
 * serverseitig im Markup, und die Dateninsel wird gar nicht erzeugt.
 */
(function () {
  var insel = document.getElementById('nb-versand-eur');
  if (!insel) return;

  var w = window.Shopify && window.Shopify.currency;
  if (!w || !w.active || w.active === 'EUR') return;
  var kurs = parseFloat(w.rate);
  if (!(kurs > 0)) return;

  var daten;
  try {
    daten = JSON.parse(insel.textContent);
  } catch (e) {
    return;
  }
  if (!daten || !daten.varianten) return;

  /* Auf zwei Stellen, wie ein Geldbetrag. Nicht auf ganze Einheiten runden:
     bei 3,49 Euro waere der Unterschied zwischen 40 und 41 NOK sichtbar
     groesser als die Genauigkeit, die wir behaupten wollen. */
  function betrag(eur) {
    return Math.round(eur * kurs * 100) / 100;
  }

  var bloecke = document.querySelectorAll('script[type="application/ld+json"]');
  for (var i = 0; i < bloecke.length; i++) {
    var block = bloecke[i];
    var doc;
    try {
      doc = JSON.parse(block.textContent);
    } catch (e) {
      continue;
    }
    if (!doc || !doc.hasVariant || !doc.hasVariant.length) continue;

    var geaendert = false;
    for (var v = 0; v < doc.hasVariant.length; v++) {
      var variante = doc.hasVariant[v];
      var angebot = variante && variante.offers;
      if (!angebot || !angebot.shippingDetails || !angebot.shippingDetails.length) continue;

      /* Zugeordnet wird ueber die Varianten-ID, nicht ueber die Reihenfolge:
         ausverkaufte Varianten koennen im Markup fehlen. Die Kennung im
         Markup ist eine Adresse und endet auf "#variant-<id>", die Insel ist
         nach der nackten ID benannt. Deshalb die Zerlegung. */
      var kennung = String(variante['@id'] || '');
      var schnitt = kennung.lastIndexOf('#variant-');
      if (schnitt < 0) continue;
      var schluessel = kennung.slice(schnitt + '#variant-'.length);
      var eintrag = daten.varianten[schluessel];
      if (!eintrag || !(eintrag.eur > 0)) continue;

      for (var s = 0; s < angebot.shippingDetails.length; s++) {
        if (angebot.shippingDetails[s].shippingRate) continue;
        angebot.shippingDetails[s].shippingRate = {
          '@type': 'MonetaryAmount',
          currency: w.active,
          /* Eigener Kassentarif in der aktiven Waehrung (Norwegen, 29.09.2026)
             statt Euro mal Tageskurs: 230 NOK, nicht 237,11. */
          value: (eintrag.lokal > 0 && eintrag.waehrung === w.active) ? eintrag.lokal : betrag(eintrag.eur),
        };
        geaendert = true;
      }
    }

    if (geaendert) block.textContent = JSON.stringify(doc);
  }
})();
